// extracted by mini-css-extract-plugin
export var actionText = "_ng-4";
export var container = "_ng-0";
export var leftSection = "_ng-1";
export var rightSection = "_ng-2";
export var settingsButton = "_ng-6";
export var settingsIcon = "_ng-7";
export var shortcut = "_ng-5";
export var shortcutGroup = "_ng-3";